class CC_Track {
    constructor(options = {}, objInit){
        this.options = Object.assign(
            {},
            {    
                checkout : false, 
                gtmID: "GTM-KL48DCKS",     
                userId : '',
                pageName : '',
                pageCategory : '',
                pageUrl : '',
                currency: "EUR"
            }, 
            options 
        );  

        this.objInit = objInit;  

        window.dataLayer = window.dataLayer || []; 
        window.gtag = function(){dataLayer.push(arguments)};  

        this.header = document.querySelector("#header");
        this.body = document.querySelector("body"); 

        window.Shopify = window.Shopify || {};

        window.Shopify.loadFeatures([
            {
            name: "consent-tracking-api",
            version: "0.1",
            }
        ],(error) => {
            if (error) {
            throw error;
            }
            this.initRgpd(); 
        });   
        
    } 
 
    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }  
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null; 
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    } 
      
 
    loadGTM(id, checkout = false){
        if(!this.options.checkout){
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":
            new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src=
            "https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,"script","dataLayer",id); 
        }   
        if(this.objInit != "" && typeof this.objInit != "undefined" && typeof this.objInit == "object"){
            this.push(this.objInit); 
        }
    } 

    async push(obj, cb){ 
        var dataInit = {
            'currency' : this.options.currency, 
            'pageLang' : this.options.pageLang, 
            'UserAuthenticated' : this.options.userAuthenticated, 
            'UserId' : this.options.userId, 
            'PageName' : this.options.pageName, 
            'pageUrl' : this.options.pageUrl 
        };
        var dataMerge = {...dataInit, ...obj};  
        window.dataLayer.push(dataMerge);   
  
        if(typeof cb != "undefined" && typeof cb == "function"){
            cb(); 
        }
    }

    initRgpd() {  
        this.loadGTM(this.options.gtmID);   
        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                preferences: true,
                analytics: true,
                marketing: true,
                sale_of_data: true
            }, 
            () => {} 
        );      
    }  
} 

const track = new CC_Track(); 